import client from "./client";

export const getAdvertisements = async () => {
  return await client({
    url: `/advertisements`,
    method: "get",
  });
};
